<template>
	<div
		id="app"
		style="min-width: 1007px;"
		:class="{mac:is_mac}"
	>
		<!-- 显示容器 -->
		<router-view />

		<UserArgePopup />
		<PrivacyArgePopup />
	</div>
</template>

<script>
import "@/common/version";
import onNetWorkStatusChange from '@/common/onNetWorkStatusChange';
import UserArgePopup from "@/components/UserArgePopup.vue";
import PrivacyArgePopup from "@/components/PrivacyArgePopup.vue";

export default {
	components: { UserArgePopup, PrivacyArgePopup },
	data() {
		function detectOS() {
			const platform = navigator.platform;
			const userAgent = navigator.userAgent;

			// 检测Mac
			if (/Mac/.test(platform)) {
				// && !/(iPhone|iPad|iPod)/.test(userAgent) 排除iOS设备（iPhone、iPad、iPod）
				return 'Mac';
			} else if (/Win/.test(platform)) {
				return 'Windows';
			} else {
				return 'Other';
			}
		}

		return {
			is_mac: detectOS() == 'Mac',

		}
	},
	created() {
		this.setRem();
		window.addEventListener("resize", () => this.setRem());

		this.$store.commit('init');
		this.$store.dispatch('getCSystemInfo');
		this.$store.dispatch('getNewNoticeNum');

		this.resetGetUserInfo();

		this.$store.commit("init_im");

		onNetWorkStatusChange.call(this);

	},
	beforeDestroy() { window.removeEventListener("resize", () => this.setRem()); },
	methods: {
		setRem() {
			const size = window.innerWidth / 1920 * 16;
			document.documentElement.style = `font-size:${size < 14 ? 14 : size}px`;
		}
	}
}
</script>

<style lang="scss">
@import './common/css/global.scss';
@import './common/css/flex.scss';
@import './common/css/animate.min.css';
@import './common/css/customGlobal.css';

// @font-face {
// 	font-family: 'Source Code Pro';
// 	src: url('~@/assets/fonts/SourceHanSansSC-Normal-2.otf');
// }

$theme: #2299ff;

#app {
	font-size: 16px;
	font-family: 'Source Code Pro', 'Microsoft YaHei', sans-serif;
	font-weight: 400;

	&.mac {
		font-family: 'PingFang SC' !important;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}

img {
	opacity: 0;
	transition: opacity 0.5s ease-in-out;
}
img.imgLoaded {
	opacity: 1;
}
</style>
